import React, {useState, useContext} from 'react'
import 'react-phone-number-input/style.css'
 
import PhoneInput from 'react-phone-number-input'
import Contex from '../Context/CreateContext'
const Contact = () => {
  const contex = useContext(Contex)
  const {sentContactData} = contex
  const [data, setdata] = useState({ fullName:"", email:'', phone:"", msg:""})
  const [value, setValue] = useState()
  const handleFormSubmit = async(e) =>{
e.preventDefault()
 
const {fullName, email, phone, msg} = data

 await sentContactData(fullName, email, phone, msg)
  }
  const   onChange= (e) =>{
    const {name, value} = e.target
    setdata({...data, [name] : value})
  }

  
  return (
    <div className='mt-36'>
    <div className="flex justify-center mt-16">
      <div className="w-4/5 md:my-5 mx-0  px-0 md:mx-auto flex flex-col items-center md:flex-row ">
        <div className="border w-full md:w-[70%] h-full bg-gray-300 text-white md:p-10 mb-2">
          <span>
            <h1 className="text-3xl font-semibold text-center mb-4 text-black">
              Contact Us
            </h1>
            <p className="text-xs font-normal mt-2 text-center">
              Contact us by filling this contact form.{" "}
            </p>
          </span>
          <div className="mt-6 leading-7 text-center">
            <form onSubmit={handleFormSubmit}>
            <input
              type="text"
              name="fullName"
              placeholder="Full Name"
              id="fullName"
              className="border-b-2 w-[80%] mb-4 p-1 border-b-white placeholder:text-white placeholder:opacity-80 text-sm bg-gray-400 focus:outline-none"
              required
              onChange={onChange}
              value = {data.fullName}
              />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              id="email"
              className="border-b-2 w-[80%] mb-4 p-1 border-b-white placeholder:text-white placeholder:opacity-80 text-sm bg-gray-400 focus:outline-none"
              required
              onChange={onChange}
              value = {data.email}
              />
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              id="phone"
              className="border-b-2 w-[80%] mb-4 p-1 border-b-white placeholder:text-white placeholder:opacity-80 text-sm bg-gray-400 focus:outline-none"
              required
              onChange={onChange}
              value = {data.phone}
              />
            <textarea
              id="message"
              name="msg"
              placeholder="Write us a message"
              className="w-[80%] bg-gray-400 border-2 border-white h-44 text-sm outline-none placeholder:text-white placeholder:opacity-80 py-1 px-2 mt-6 resize-none leading-6 duration-200 ease-in-out rounded-lg"
              onChange={onChange}
              required
              value={data.msg}
              />
            <button   className="block m-auto w-[60%] md:w-[50%] text-center border bg-yellow-300 rounded-full py-1 md:py-0 mt-6 md:text-lg md:font-bold md:tracking-wide uppercase text-black brightness-105 hover:bg-yellow-400">
           under developing
            </button>
            </form>
          </div>
        </div>
        <div className="border w-full md:w-[40%] bg-gray-100 items-center flex flex-col justify-center leading-7 space-y-8 p-8 h-full">
          <img
            src="/home_hira.jpeg"
            alt=""
            className=""
          />
          <p className="text-black">
          Online test data generator. Generate test data for free and export in CSV Excel SQL and Json. 100.000 records. Random name, string, address, email and guid. 
          </p>
        </div>
      </div>
    </div>
    </div>
  )
}

export default Contact